import React from 'react';

import { Table, TableRow, TableBody, TableHead } from '@mui/material';

import { useSelector, useDispatch } from 'react-redux';
import { selectEvents } from '../../store/episodes/episodes.selector';
import { changeEventDisplayVisible } from '../../store/ui/ui.slice';
import {
  selectHazardMetric,
  selectIsClimate,
} from '../../store/options/options.selector';

import Section from '../section/section.component';
import CloseBtn from '../close-btn/close-btn.component';
import EDTRow from './event-display-table-row.component';
import StyledTableCell from './styled-table-cell.component';

import './event-display.styles.scss';
import {
  selectIsChartVisible,
  selectIsEpisodeTimelineVisible,
  selectIsEventDisplayVisible,
} from '../../store/ui/ui.selector';

export default function EventDisplay() {
  const dispatch = useDispatch();
  const eventsInfo = useSelector(selectEvents);
  const metric = useSelector(selectHazardMetric);
  const isClimate = useSelector(selectIsClimate);
  const isChartVisible = useSelector(selectIsChartVisible);
  const isEpisodeTimelineVisible = useSelector(selectIsEpisodeTimelineVisible);
  const isEventDisplayVisible = useSelector(selectIsEventDisplayVisible);
  const isVisible =
    !isClimate &&
    isChartVisible &&
    isEpisodeTimelineVisible &&
    isEventDisplayVisible;

  const handleClose = () => {
    dispatch(changeEventDisplayVisible(false));
  };

  return (
    <Section
      className='event-display-container fadeable'
      sx={{
        opacity: isVisible ? 1 : 0,
        pointerEvents: isVisible ? 'all' : 'none',
      }}
    >
      <CloseBtn handleClose={handleClose} />

      <div className='event-display-title'>
        {eventsInfo.attrName} events{' '}
        {eventsInfo.date.length === 5
          ? `on ${eventsInfo.date}`
          : `from ${eventsInfo.date.split('-').join(' to ')}`}{' '}
        in {eventsInfo.location}
      </div>

      {eventsInfo.events.length === 0 ? (
        <div>
          The selected episode contains no events for the selected impact.
        </div>
      ) : (
        <div className='event-display-table'>
          <Table
            size='small'
            sx={{
              border: '2px solid rgb(220,220,220)',
            }}
          >
            <TableHead>
              <TableRow>
                <StyledTableCell
                  colSpan={1}
                  sx={{
                    borderRight: '1px solid rgb(220,220,220)',
                  }}
                />
                <StyledTableCell
                  colSpan={metric === 'count' ? 4 : 1}
                  sx={{
                    borderLeft: '1px solid rgb(200,200,200)',
                  }}
                >
                  Total Reported Amount{metric === 'count' ? 's' : ''}
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell
                  sx={{ borderRight: '1px solid rgb(220,220,220)' }}
                >
                  Event Id
                </StyledTableCell>
                {(metric === 'count' || metric === 'damageCrops') && (
                  <StyledTableCell>Crop Damage</StyledTableCell>
                )}
                {(metric === 'count' || metric === 'damageProperty') && (
                  <StyledTableCell>Property Damage</StyledTableCell>
                )}
                {(metric === 'count' || metric === 'deaths') && (
                  <StyledTableCell>Deaths</StyledTableCell>
                )}
                {(metric === 'count' || metric === 'injuries') && (
                  <StyledTableCell>Injuries</StyledTableCell>
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {eventsInfo.events.map((event) => (
                <EDTRow key={event.id} {...event} metric={metric} />
              ))}
              {eventsInfo.events.length > 1 && (
                <TableRow>
                  <StyledTableCell
                    variant='head'
                    sx={{ borderRight: '1px solid rgb(220,220,220)' }}
                  >
                    Episode Totals
                  </StyledTableCell>
                  {(metric === 'count' || metric === 'damageCrops') && (
                    <StyledTableCell variant='head'>
                      ${eventsInfo.totals.crop}
                    </StyledTableCell>
                  )}
                  {(metric === 'count' || metric === 'damageProperty') && (
                    <StyledTableCell variant='head'>
                      ${eventsInfo.totals.prop}
                    </StyledTableCell>
                  )}
                  {(metric === 'count' || metric === 'deaths') && (
                    <StyledTableCell variant='head'>
                      {eventsInfo.totals.death}
                    </StyledTableCell>
                  )}
                  {(metric === 'count' || metric === 'injuries') && (
                    <StyledTableCell variant='head'>
                      {eventsInfo.totals.injury}
                    </StyledTableCell>
                  )}
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
      )}
    </Section>
  );
}
